import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Icon, Text } from '../..';
import { AVATAR_DEFAULT_DOT, AVATAR_DEFAULT_MODE, AVATAR_DEFAULT_SCHEMA, AVATAR_DEFAULT_SIZE, AVATAR_DEFAULT_VARIANT, AVATAR_SIZE_TO_ICON_SIZE } from './Avatar.constants';
import { AvatarRoot } from './Avatar.styled';
// Component.
// -----------------------------------------------------------------------------
const Avatar = forwardRef(({ icon: iconProps, img: imgProps, showDot = AVATAR_DEFAULT_DOT, size = AVATAR_DEFAULT_SIZE, text: textProps, color, ...rest }, ref) => {
    const mode = textProps?.mode || AVATAR_DEFAULT_MODE;
    const schema = textProps?.schema || AVATAR_DEFAULT_SCHEMA;
    const variant = textProps?.variant || AVATAR_DEFAULT_VARIANT;
    return (_jsx(AvatarRoot, { mode: mode, ref: ref, schema: schema, showDot: showDot, size: size, variant: variant, color: color, ...rest, children: imgProps ? (_jsx("img", { alt: imgProps.alt, src: imgProps.src })) : textProps ? (_jsx("div", { className: "avatar-text", children: _jsx(Text, { size: size, uppercase: true, children: textProps.text }) })) : iconProps ? (_jsx("div", { className: "avatar-icon", children: _jsx(Icon, { icon: iconProps.icon, size: AVATAR_SIZE_TO_ICON_SIZE[size] }) })) : null }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Avatar.displayName = 'Avatar';
export default Avatar;
//# sourceMappingURL=Avatar.js.map